import { defineComponent as _defineComponent } from 'vue'
import useGetAccessToken from "@/use/useGetAccessToken";
import useGetProtocolHost from "@/use/useGetProtocolHost";
import { KCPResult, SERVICE_UID } from "@/types";


const __default__ = {
  name: "CancelKcp",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  isDailyBook: {
    type: Boolean,
    default: false,
  },
  bookUid: {
    type: String,
  },
  bookDetailUid: {
    type: String,
  },
},
  emits: ["onBookCancelResult"],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const cancelKCP = () => {
  const kcpCancelForm = document.forms.namedItem(
    "kcpCancelForm"
  ) as HTMLFormElement;
  const baseUrl = `${useGetProtocolHost()}/aibos/client/api`;
  const contextPath = `${baseUrl}/${process.env.VUE_APP_API_VERSION}/service/${SERVICE_UID}/cancel-kcp`;
  kcpCancelForm.target = "kcpCancelFrame";
  kcpCancelForm.action = contextPath;
  kcpCancelForm.bookUid.value = props.bookUid;
  if (props.isDailyBook) {
    kcpCancelForm.bookDetailUid.value = props.bookDetailUid;
  }
  kcpCancelForm.submit();
};

window.paymentResult = (result: KCPResult) => {
  emit("onBookCancelResult", result);
};

__expose({ cancelKCP });

const __returned__ = { props, emit, cancelKCP, get useGetAccessToken() { return useGetAccessToken } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})